
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// ./~/socket.io-client/~/engine.io-client/~/component-inherit/index.js
// module id = 209
// module chunks = 0